<vn-icon class="icon-acca-boost" [name]="showErrorIcon ? 'theme-acca-boost-error' : 'theme-acca-boost'" [size]="iconSize.toString()" />
